declare namespace $ {

	type $mol_view__sub_bog_smalljs_versus_code_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_code_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_code['columns'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_bog_smalljs_versus_code_3 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_code['column_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_smalljs_versus_code_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_code_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_bog_smalljs_versus_code_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_versus_code_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_expander__title_bog_smalljs_versus_code_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_code['title'] >
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_smalljs_versus_code_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_view__sub_bog_smalljs_versus_code_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_code_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_versus_code extends $mol_view {
		body( ): readonly(any)[]
		Hint( ): $mol_view
		columns( ): readonly(any)[]
		Columns( ): $mol_view
		column_name( id: any): string
		column_uri( id: any): string
		column_file( id: any): string
		Column_file( id: any): $mol_link
		Column_head( id: any): $mol_view
		column_text( id: any): string
		Column_code( id: any): $mol_view
		missing_text( ): string
		case_id( ): string
		left( ): string
		right( ): string
		title( ): string
		hint( ): string
		missing( ): string
		sub( ): ReturnType< $bog_smalljs_versus_code['body'] >
		Expander( ): $mol_expander
		Column( id: any): $mol_view
		Missing( ): $mol_view
	}
	
}

//# sourceMappingURL=code.view.tree.d.ts.map